import { em } from 'polished'
import styled from 'styled-components'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'

export const FirstBlockWrapperStyled = styled(FirstBlockWrapper)`
  overflow: hidden;
  color: ${p => p.theme.colors.white};
`

export const TextWrapper = styled.div`
  display: inline-block;
  ${p => p.theme.mq.upLg} {
    max-width: 80%;
  }
`

export const ScrollDownWrapper = styled.div`
  padding-top: ${em(80)};
`
